<template>
  <div class="relative w-full bg-neutral-25 rounded-xl border border-neutral-25 overflow-hidden pointer-events-none" style="height: 120px;">
    <div class="browser-preview-container">
      <div class="text-block px-1.5 py-1 bg-neutral-25 text-text-muted">
        300K+ People
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsletterFeaturesPreview'
}
</script>

<style scoped>
.browser-preview-container {
  position: absolute;
  left: 16px;
  top: 16px;
  background-color: white;
  width: 320px;
  height: 140px;
  box-shadow: 0 48px 48px -32px rgba(47, 53, 71, 0.08), 0 40px 40px -24px rgba(47, 53, 71, 0.08), 0 24px 24px -12px rgba(47, 53, 71, 0.08), 0 12px 12px -8px rgba(47, 53, 71, 0.08), 0 4px 4px -3px rgba(47, 53, 71, 0.08);
}
.text-block {
  position: absolute;
  left: 6px;
  top: 8px;
  border-radius: 24px;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
}
</style>